import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllWorkItems } from '../utils/workUtils';

const WorkSection = () => {
  const [workItems, setWorkItems] = useState([]);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const items = await getAllWorkItems();
        if (isMounted) {
          setWorkItems(Array.isArray(items) ? items : []);
        }
      } catch (_) {
        if (isMounted) setWorkItems([]);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);
  
  // Take only the first 3 items for the home page display
  const projects = (workItems || []).slice(0, 3).map(item => ({
    title: item.title,
    image: item.image,
    description: item.description,
    badge: item.badge,
    link: item.link
  }));

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="w-full lg:max-w-7xl lg:mx-auto">
        <h2 className="text-4xl lg:text-5xl font-bold text-center mb-16">work & case studies</h2>
        
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {projects.map((project, index) => (
            <Link key={index} to={project.link} className="group block h-full">
              <div className="card bg-gray-50 shadow-sm hover:shadow-md transition-shadow duration-200 h-full flex flex-col">
                <figure>
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-3/4 aspect-[4/3] py-4 object-cover group-hover:scale-105 transition-transform duration-200"
                  />
                </figure>
                <div className="card-body flex-1 flex flex-col">
                  <h3 className="card-title text-xl font-bold">{project.title}</h3>
                  <p className="text-base-content/70 font-extralight line-clamp-2">{project.description}</p>
                  <span className="badge bg-orange-500 text-white border-0 mt-3">{project.badge}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/work" 
            className="font-light italic text-3xl px-8 py-2 hover:border-b-2 hover:border-orange-500 transition-all duration-300"
          >
            see more work →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WorkSection; 